/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { Button, Hidden, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

import type { NormalizedNotStartedCourse } from '../types/courseStates';

type Props = {
  upcomingCourses: NormalizedNotStartedCourse[];
};

const styles = {
  itemsListContainer: () => css`
    overflow-y: auto;
    max-height: 0;
    transition: 0.4s max-height;

    p {
      padding: 0.5rem 0;
    }

    p:not(:first-child) {
      border-top: 1px solid var(--cds-color-grey-50);
    }
  `,
  collapseBtn: css`
    width: 100%;
  `,
};

const MobileUpcomingCoursesItemsList = ({ upcomingCourses }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const onBtnClick = () => setIsCollapsed((prevState) => !prevState);

  // if only has one upcoming course, no need to render list
  if (upcomingCourses.length < 2) return null;

  return (
    <Hidden smUp>
      <div role="list" css={styles.itemsListContainer} style={{ maxHeight: isCollapsed ? '0' : '300px' }}>
        {upcomingCourses.map((course) => (
          <Typography2 component="p" variant="bodyPrimary" id={course.id} role="listitem">
            {course.name}
          </Typography2>
        ))}
      </div>
      <Button css={styles.collapseBtn} variant="ghost" onClick={onBtnClick}>
        {isCollapsed ? _t('Show more') : _t('Show less')}
      </Button>
    </Hidden>
  );
};

export default MobileUpcomingCoursesItemsList;
